export default "__VITE_ASSET__LtgXbtpx__"